export const dismissOpenTooltips = (): void => {
  if (!document.querySelector('.Polaris-Tooltip-TooltipOverlay')) return;
  document
    .querySelectorAll<HTMLElement>('[data-polaris-tooltip-activator="true"]')
    .forEach((el) => {
      el.blur();
      el.dispatchEvent(new MouseEvent('mouseout', { bubbles: true, relatedTarget: document.body }));
    });
};
